export const MinimapIcon = ({ onClick }: { onClick: () => void }) => {
  return (
    <div
      className="group pointer-events-auto absolute bottom-2 right-2 h-30px w-30px cursor-pointer drop-shadow-[0px_2px_2px_rgba(0,0,0,0.15)]"
      onClick={onClick}
    >
      <svg
        fill="none"
        height="30"
        viewBox="0 0 30 30"
        width="30"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g filter="url(#filter0_d_1_6)">
          <rect
            className="transition-all group-hover:[x:0.5] group-hover:[y:0.5] group-hover:h-29px group-hover:w-29px group-hover:fill-neutral-300 group-hover:stroke-neutral-800"
            fill="transparent"
            height="21"
            rx="14.5"
            stroke="white"
            width="21"
            x="4.5"
            y="4.5"
          />
          <path
            className="transition-all group-hover:stroke-neutral-800"
            d="M9.16688 9.16378L23.1827 14.8417L16.3191 16.3107L14.849 23.1692L9.16688 9.16378Z"
            stroke="white"
            strokeLinejoin="round"
          />
        </g>
        <defs>
          <filter
            colorInterpolationFilters="sRGB"
            filterUnits="userSpaceOnUse"
            height="34"
            id="filter0_d_1_6"
            width="34"
            x="-2"
            y="-2"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              result="hardAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            />
            <feOffset />
            <feGaussianBlur stdDeviation="1" />
            <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
            <feBlend in2="BackgroundImageFix" mode="normal" result="effect1_dropShadow_1_6" />
            <feBlend in="SourceGraphic" in2="effect1_dropShadow_1_6" mode="normal" result="shape" />
          </filter>
        </defs>
      </svg>
    </div>
  );
};
